import { render, staticRenderFns } from "./WaitingForHelpInfo.vue?vue&type=template&id=47856813&"
import script from "./WaitingForHelpInfo.vue?vue&type=script&lang=js&"
export * from "./WaitingForHelpInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports